import React, { useContext, useState, useEffect } from "react";
import { EmplContext } from "../Login_Page/Login_Page/LoginPage";
import configData from "../../config.json";
import './Company_policy.css';
import LoadingComponent from "../loading_component";

function Company() {
  const [policies, setPolicies] = useState([]);
  const [activeFile, setActiveFile] = useState(null); // Stores active file for dropdown
  const { resultData } = useContext(EmplContext);
  const employee_id = resultData.employee_id || 0;
  const [load, setLoading] = useState(true);

  useEffect(() => {
    fetchPolicies();
  }, [employee_id]);

  const fetchPolicies = async () => {
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { employee_id, secretKey };

      const response = await fetch(`${configData.SERVER_URL}/companyPolicy`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      const result = data.result;

      if (result?.success) {
        setPolicies(result.policy_data || []);
      } else {
        console.error("Error fetching policies:", result?.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const PREVIEWABLE = ['application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'video/mp4'];

  const getBlob = (base64Data, mimeType) => {
    const clean = base64Data.replace(/^data:[^;]+;base64,/, '').replace(/\s/g, '');
    const bytes = Uint8Array.from(atob(clean), c => c.charCodeAt(0));
    return new Blob([bytes], { type: mimeType });
  };

  const handleFile = (file, name, mimeType) => {
    const url = URL.createObjectURL(getBlob(file, mimeType));
    if (PREVIEWABLE.includes(mimeType)) {
      window.open(url, '_blank');
    } else {
      const a = Object.assign(document.createElement('a'), { href: url, download: name });
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  };

  const downloadFile = (file, name, mimeType) => {
    const url = URL.createObjectURL(getBlob(file, mimeType));
    const a = Object.assign(document.createElement('a'), { href: url, download: name });
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  // const downloadFile = (base64Data, fileName) => {
  //   const link = document.createElement("a");
  //   link.href = `data:application/octet-stream;base64,${atob(base64Data)}`;
  //   link.download = fileName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  // const toggleDropdown = (event, file) => {
  //   event.stopPropagation(); // Prevents event bubbling
  //   setActiveFile(activeFile === file ? null : file);
  // };
  // useEffect(() => {
  //   const handleClickOutside = () => {
  //     setActiveFile(null); // Hide buttons when clicking anywhere else
  //   };

  //   document.addEventListener("click", handleClickOutside);
  //   return () => document.removeEventListener("click", handleClickOutside);
  // }, []);

  const groupedPolicies = policies.reduce((acc, policy) => {
    if (!acc[policy.category]) acc[policy.category] = [];
    acc[policy.category].push(policy);
    return acc;
  }, {});

  // const base64ToBlob = (base64, mimeType) => {
  //   const byteCharacters = atob(base64);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   return new Blob([byteArray], { type: mimeType });
  // };

  // const openPdf = (base64Data) => {
  //   const cleanData = cleanBase64(base64Data);

  //   console.log("Starts with JVBER?", cleanData.startsWith("JVBER"));

  //   const byteCharacters = atob(cleanData);
  //   console.log("Decoded byte length:", byteCharacters.length);

  //   const byteArray = new Uint8Array(
  //     [...byteCharacters].map((c) => c.charCodeAt(0))
  //   );

  //   console.log("Uint8Array length:", byteArray.length);

  //   const blob = new Blob([byteArray], { type: "application/pdf" });
  //   console.log("Blob size:", blob.size);

  //   const url = URL.createObjectURL(blob);
  //   console.log("Blob URL:", url);

  //   window.open(url, "_blank");
  // };



  // const cleanBase64 = (base64) => {
  //   const cleaned = base64
  //     .replace(/^data:application\/pdf;base64,/, "")
  //     .replace(/\s/g, "");

  //   console.log("CLEAN base64 (first 200):", cleaned.slice(0, 200));
  //   console.log("CLEAN base64 length:", cleaned.length);

  //   return cleaned;
  // };




  // const downloadFile = (base64Data, fileName) => {
  //   const blob = base64ToBlob(base64Data, "application/pdf");
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`;

  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  //   URL.revokeObjectURL(url);
  // };




  return (
    <>
    {load ? (
      <div className="main-panel">
        <LoadingComponent/>
      </div>
    ) : (
    <div className="company-container">
      <div className="al_holi">
        <h2 className="al_holi_tl">Company Policy</h2>
      </div>
      {Object.keys(groupedPolicies).length > 0 ? (
        <div>
          {Object.keys(groupedPolicies).map((category) => (
            <div key={category} className="policy-category">
              <h5 className="category-name">{category}</h5>
              <div className="policy-list">
                {groupedPolicies[category].map((policy, index) => (
                  <div key={index} className="policy-item-container">

                    <div className="policy-item">
                      <div onClick={() => handleFile(policy.file, policy.name, policy.mime_type)}>
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                          alt="document"
                          width="30px"
                        />
                        <p className="policy-name">{policy.name}</p>
                      </div>

                      {/* DOWNLOAD ICON */}
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/724/724933.png"
                        alt="download"
                        width="16px"
                        className="download-icon"
                        onClick={() => downloadFile(policy.file, policy.name, policy.mime_type)}
                      />
                    </div>






                    {/* 
                    {activeFile === policy && (
                      <div className="overlay-buttons">
                        <button
                          onClick={() => openPdf(policy.file)}
                          className="overlay-btn open-btn"
                        >
                          Open
                        </button>
                        <button onClick={() => downloadFile(policy.file, policy.name)} className="overlay-btn download-btn">
                          Download
                        </button>
                      </div>
                    )}*/}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="no-policies-message">No policies found</p>
      )}
    </div>
    )}
    </>
  );
}

export default Company;
